module.exports = "/static/media/design-icon-white.cc2c2264.png";